import { Vue } from 'ui.vue';
import { Loc, Currency } from 'main.core';
// import { storageAvailable } from 'germes.multibasket';
userStore.registerModule('contragent', {
    namespaced: true,
    state: {
        initHandler: false,
        CONTRAGENTS: {},
        ProductSettingsModule: [],
        isCachedRequestContragentsActions: false
    },
    mutations: {
        contragentBonus: function (state, item) {
            // if (state.ITEMS[item.ID] == undefined) {
            //     BX.Vue.set(item, "PRICE", item.PRICE);
            //     BX.Vue.set(item, "DISCOUNT_PRICE", item.DISCOUNT_PRICE);
            //     BX.Vue.set(item, "ANALOG", item.ANALOG); // список аналогов
            //     BX.Vue.set(item, "PROPS", item.PROPS);
            // } else {
            //     this.commit('catalog/updateItem', item);
            // }
        },
        setAction: function (state, { contragent, action }) {
            if (contragent && action) {
                let event = { contragent: contragent, action: action, result: true };
                BX.onCustomEvent('OnBeforeContragentSetAction', event);
                if (event.result == true && action.CODE) {
                    if (contragent.ACTIONS == undefined) {
                        Vue.set(contragent, 'ACTIONS', {});
                    }
                    Vue.set(contragent.ACTIONS, action.CODE, event.action);
                    BX.onCustomEvent("OnAfterContragentSetAction", event);
                }
            }
        },
    },
    actions: {
        initEventHandler: function (store) {
            if (store.state.initHandler === false) {
                // request actions and set product labels
                BX.addCustomEvent("OnAfterBasketStoreInit", BX.delegate((event) => {
                    this.dispatch('contragent/requestContragentsActions', this.getters['contragent/getContragentList']).then((result) => {
                    });
                }, this));
                BX.addCustomEvent("OnAfterContragentListSetActionList", BX.delegate((event) => {
                    this.dispatch('contragent/setCatalogLabelList').then((result) => {
                        //
                    });
                    // update product labels
                    BX.addCustomEvent("OnCatalogItemInit", BX.delegate((event) => {
                        this.dispatch('contragent/setCatalogProductLabelList', event.data.catalogProduct).then((result) => {
                            //
                        });
                    }, this));
                }, this));
                BX.ready(BX.proxy(function () {
                    BX.onCustomEvent("OnAfterContragentStoreInit");
                }, this));
                store.state.initHandler = true;
            }
        },
        requestContragentsActions: function (store, contragentList) {
            let contragentList_XML_ID = {};
            if (contragentList) {
                if (Object.keys(contragentList)?.length) {
                    Object.fromEntries = arr => Object.assign({}, ...Array.from(arr, ([k, v]) => ({ [k]: v })));
                    contragentList_XML_ID = Object.fromEntries(Object.entries(contragentList).map(
                        ([key, contragent]) => [key, contragent.UF_XML_ID]
                    ));
                }
            }
            if (contragentList_XML_ID != undefined
                && this.getters['getUserId']
                && Object.keys(contragentList_XML_ID)?.length
            ) {
                let storeContragentsActions = {},
                    contragentsActionsLocalStorageName = this.getters['getUserId'] + 'contragentsActions',
                    is_clear_cache = (new URL(document.location))?.searchParams?.get("clear_cache") == "Y";

                if (!is_clear_cache && storageAvailable('localStorage') && localStorage.getItem(contragentsActionsLocalStorageName)) {
                    storeContragentsActions = JSON.parse(localStorage.getItem(contragentsActionsLocalStorageName));
                }
                // INFO we use the data in the browser until the end of the day
                if (storeContragentsActions?.ttl > Date.now() && storeContragentsActions?.data !== null) {
                    this.dispatch('contragent/setContragentListActionList', storeContragentsActions.data);
                    return this.state.isCachedRequestContragentsActions = true;
                } else {
                    return this.dispatch('submit', {
                        contragents_id: contragentList_XML_ID,
                        clear_cache: (is_clear_cache ? 'Y' : 'N'),
                        timeout: 600,
                        action: 'GETACTIONS'
                    }).then(response => {
                        if (storageAvailable('localStorage')) {
                            localStorage.setItem(contragentsActionsLocalStorageName, JSON.stringify({
                                data: response.data,
                                ttl: new Date().setHours(23, 59, 59, 999)
                            }));
                            storeContragentsActions = JSON.parse(localStorage.getItem(contragentsActionsLocalStorageName));
                        }
                        this.dispatch('contragent/setContragentListActionList', response.data);
                        return this.state.isCachedRequestContragentsActions = false;
                    }, error => {
                        console.error(error);
                    });
                }
            } else {
                console.debug('No contragents to get actions!');
            }
            return false;
        },
        setContragentListActionList: function ({ state, getters, rootState, rootGetters }, contragentsActions) {
            if (contragentsActions) {
                let event = { contragentsActions: contragentsActions, result: true };
                BX.onCustomEvent('OnBeforeContragentListSetActionList', event);
                for (const action_xml_id in contragentsActions) {
                    if (Object.hasOwnProperty.call(contragentsActions, action_xml_id)) {
                        const action = contragentsActions[action_xml_id];
                        for (const contragent_id in action.CONTRAGENTS) {
                            if (Object.hasOwnProperty.call(action.CONTRAGENTS, contragent_id)) {
                                let contragent = this.getters['contragent/getContragent'](contragent_id);
                                this.commit("contragent/setAction", { contragent, action });
                            }
                        }
                    }
                }
                BX.onCustomEvent("OnAfterContragentListSetActionList", event);
            }
        },
        setCatalogProductLabelList: function (store, catalogProduct) {
            if (typeof catalogProduct !== 'undefined') {
                let contragent = this.getters['basket/getContragent'],
                    actionList = contragent?.ACTIONS;
                if (actionList) {
                    for (const i in actionList) {
                        if (Object.hasOwnProperty.call(actionList, i)) {
                            const action = actionList[i]
                            if (action.ITEMS.find(val => val == catalogProduct.PRODUCT_XML_ID)) {
                                this.commit('catalog/setProductLabel', {
                                    product_xml_id: catalogProduct.PRODUCT_XML_ID,
                                    contragent_id: contragent.ID,
                                    labelData: {
                                        ID: action.ID,
                                        NAME: action.NAME,
                                        CODE: action.CODE,
                                        TITLE: action.TITLE,
                                        LINK: (action.LINK ?? '/actions/' + action.ID + '/')
                                    }
                                });
                            }
                        }
                    }
                }
            }
        },
        setCatalogLabelList: function (store) {
            let contragentList = this.getters['contragent/getContragentList'];
            if (contragentList) {
                for (const i in contragentList) {
                    if (Object.hasOwnProperty.call(contragentList, i)) {
                        let contragent = contragentList[i],
                            actionList = contragent?.ACTIONS;
                        if (actionList) {
                            for (const i in actionList) {
                                if (Object.hasOwnProperty.call(actionList, i)) {
                                    const action = actionList[i];
                                    let labelData = {
                                        ID: action.ID,
                                        NAME: action.NAME,
                                        CODE: action.CODE,
                                        TITLE: action.TITLE,
                                        LINK: (action.LINK ?? '/actions/' + action.ID + '/')
                                    };
                                    for (const k in action.ITEMS) {
                                        this.commit('catalog/setProductLabel', {
                                            product_xml_id: action.ITEMS[k],
                                            contragent_id: contragent.ID,
                                            labelData: labelData
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    },
    getters: {
        localize: (state) => (CODE) => {
            return BX.Vue.getFilteredPhrases('')[CODE];
        },
        getContragentList: (state, getters, rootState, rootGetters) => {
            return rootGetters['getContragents'];
        },
        getContragent: (state, getters, rootState, rootGetters) => (contragent_id) => {
            return getters.getContragentList[contragent_id];
        },
        getContragentActions: (state, getters, rootState, rootGetters) => (contragent_id) => {
            let contragentActionList = getters.getContragentList[contragent_id]?.ACTIONS;
            if (contragentActionList) {
                for (const action_id in contragentActionList) {
                    if (Object.hasOwnProperty.call(contragentActionList, action_id)) {
                        let actionProductList = contragentActionList[action_id].ITEMS;
                        for (const i in actionProductList) {
                            if (Object.hasOwnProperty.call(actionProductList, i)
                                && actionProductList[i].UF_XML_ID_ITEM !== undefined
                            ) {
                                actionProductList[i] = actionProductList[i].UF_XML_ID_ITEM;
                            }
                        }
                    }
                }
            }
            return contragentActionList;
        },
        getContragentAction: (state, getters, rootState, rootGetters) => (contragent_id, action_id) => {
            return getters.getContragentActions(contragent_id)?.ACTIONS[action_id] || {};
        },
    }
});
userStore.dispatch('contragent/initEventHandler');
function storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
};
export { storageAvailable }
